class MosaicGrid extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-mosaic-container]');
    this.viewMoreButton = this.querySelector('[data-mosaic-view-more]');

    if (this.viewMoreButton) {
      this.viewMoreButton.addEventListener('click', this.toggleView.bind(this));
    }
  }

  toggleView() {
    this.container.classList.toggle('is-expanded');
    this.viewMoreButton.style.display = 'none';
  }
}

customElements.define('mosaic-grid', MosaicGrid);
